/*** SLICK CAROUSELS ***/

$(document).ready(function() {
  $('.home-slick').slick({
    lazyLoad: 'progressive',
    slidesToShow: 4,
    prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-left</title><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>',
    nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-right</title><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>',
    responsive: [
      {breakpoint: 1100, settings: {slidesToShow: 3}},
      {breakpoint: 768, settings: {slidesToShow: 2, centerMode: true, slidesToScroll: 2}}
    ]
  });
})

/*** SEARCH HEADER ***/

$('#search-bar-resp-btn').click(function() {
  $('#search-bar').addClass('active');
  $('#search-bar input').focus();
})

$('#search-bar-close').click(function() {
  $('#search-bar').removeClass('active');
})

/*** SIDE NAV ***/

$('.menu.dropdown-child').slideUp();

$('.dropdown-title').click(function() {
  if ($(this).hasClass('collapsed')) {
    $(this).next('.dropdown-child').slideUp();
    $(this).removeClass('collapsed');
  } else {
    $(this).next('.dropdown-child').slideDown();
    $(this).addClass('collapsed');
  }
})

$('#menu-responsive-btn').click(function() {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('#menu-responsive-container').removeClass('active');
  } else {
    $(this).addClass('active');
    $('#menu-responsive-container').addClass('active');
  }
})

$('#menu-responsive-overlay').click(function() {
  if ($('#menu-responsive-btn').hasClass('active')) {
    $('#menu-responsive-btn').removeClass('active');
    $('#menu-responsive-container').removeClass('active');
  } else {
    $('#menu-responsive-btn').addClass('active');
    $('#menu-responsive-container').addClass('active');
  }
})

$('#site-header').sticky({topSpacing:0});

/*** ACCORDIONS ***/

$('.accordion').find('.accordion-content').hide();

// Accordion
$('.accordion').find('.accordion-header').on('click', function () {
  var next = $(this).next();
  if ($(this).hasClass('toggled')) {
    $(this).removeClass('toggled');
  } else {
    $(this).parents('.accordion').find('.accordion-header').removeClass('toggled');
    $(this).addClass('toggled');
  }
  next.slideToggle('fast');
  $('.accordion-content').not(next).slideUp('fast');
  return false;
});

/*** SHANTY RANGES ***/

$(document).ready(function() {
    $('.shanty-range').each(function() {
        $(this).find('.shanty-range-nb').text($(this).find('.shanty-range-values span:first-child').attr('data-label'));
        $(this).find('.shanty-range-value').text($(this).find('.shanty-range-values span:first-child').attr('data-value'));

        $(this).find('.shanty-range-input').append('<div class="shanty-range-input-slider"></div><div class="shanty-range-input-cursor"></div>');
    })
})

$('.shanty-range').on('input', '.shanty-range-input', function() {
    const val = $(this).find('input').val();
    const max = $(this).find('input').attr('max');
    const min = $(this).find('input').attr('min');

    $(this).parents('.shanty-range').find('.shanty-range-nb').text($(this).parents('.shanty-range').find('.shanty-range-values span:nth-child(' + val + ')').attr('data-label'));
    $(this).parents('.shanty-range').find('.shanty-range-value').text($(this).parents('.shanty-range').find('.shanty-range-values span:nth-child(' + val + ')').attr('data-value'));

    $(this).find('.shanty-range-input-cursor').css('left', 'calc(calc(calc(100% / ' + (max - 1) + ') * ' + (val - 1) + ') - 10px)');
})